<script>
import { defineAsyncComponent } from 'vue'
import BaseIcon from '@/aasgard/components/base/BaseIcon.vue'

export default {
  name: 'BaseIconImpl',
  extends: BaseIcon,
  props: {
    url: {
      type: [Function, Object, String],
      default: '',
    },
  },
  computed: {
    icon() {
      try {
        if (!this.name) {
          return ''
        }
        if (this.url) {
          return this.url
        }
        return defineAsyncComponent(
          () =>
            import(
              `../../aasgard/assets/img/icons/ico-${this.name}.svg?component`
            ),
        )
      } catch (error) {
        return ''
      }
    },
  },
}
</script>
